/**
 * @file Tunnel constant
 * @module constant.tunnel
 * @author Surmon <https://github.com/surmon-china>
 */

export enum TunnelModule {
  TwitterUserInfo = 'twitter_userinfo',
  TwitterTweets = 'twitter_tweets',
  YouTubePlaylist = 'youtube_playlist',
  YouTubeVideoList = 'youtube_video_list',
  BiliBili = 'bilibili',
  Instagram = 'instagram',
  Wallpaper = 'wallpaper',
  GitHub = 'gitHub',
  Music = 'music'
}
